<div
  class="w-max font-medium hover:underline active:underline underline-offset-2 duration-300 transition-all cursor-pointer select-none whitespace-nowrap"
  [ngClass]="cssClasses"
>
  {{ title }}
</div>
